import {
  OR_REQUEST_ORDERS,
  OR_RECEIVE_ORDERS,
  OR_RECEIVE_ORDERS_ERROR,
  OR_TOGGLE_FUTURE_ORDERS_SECTION,
  OR_BUILD_ORDER_REQUEST,
  OR_BUILD_ORDER_SUCCESS,
  OR_BUILD_ORDER_ERROR,
} from '../../actions/management/orOrders';
import { OR_ORDER_CANCEL_SUCCESS } from '../../actions/management/cancelOrder';

function addPendingBuildOrder(state, orderNumber) {
  if (!orderNumber || state.pendingBuildOrders.includes(orderNumber)) {
    return state;
  }
  const newPendingBuildOrders = state.pendingBuildOrders.concat(orderNumber);

  return {
    ...state,
    pendingBuildOrders: newPendingBuildOrders,
  };
}

function removePendingBuildOrder(state, orderNumber, { addToErrorBuildOrders } = {}) {
  if (!orderNumber) {
    return state;
  }
  const newPendingBuildOrders = state.pendingBuildOrders.filter(o => o !== orderNumber);
  let newErrorBuildOrders;

  if (addToErrorBuildOrders) {
    newErrorBuildOrders = !state.errorBuildOrders.includes(orderNumber)
      ? state.errorBuildOrders.concat(orderNumber)
      : state.errorBuildOrders;
  } else {
    newErrorBuildOrders = state.errorBuildOrders.filter(o => o !== orderNumber);
  }

  return {
    ...state,
    pendingBuildOrders: newPendingBuildOrders,
    errorBuildOrders: newErrorBuildOrders,
  };
}

export const initialState = {
  ordersList: [],
  isFetchingOrders: false,
  isFetchingOrdersError: false,
  isFutureOrdersSectionVisible: false,
  pendingBuildOrders: [],
  errorBuildOrders: [],
};

export default function ordersReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REQUEST_ORDERS:
      return { ...state, isFetchingOrders: true };
    case OR_RECEIVE_ORDERS:
      return {
        ...state,
        ordersList: action.data,
        isFetchingOrders: false,
        isFetchingOrdersError: false,
      };
    case OR_RECEIVE_ORDERS_ERROR:
      return {
        ...state,
        ordersList: [],
        isFetchingOrders: false,
        isFetchingOrdersError: true,
      };
    case OR_ORDER_CANCEL_SUCCESS: {
      const { orderNumber } = action;
      return {
        ...state,
        ordersList: state.ordersList.filter(order => order.orderNumber !== orderNumber),
      };
    }
    case OR_TOGGLE_FUTURE_ORDERS_SECTION:
      return {
        ...state,
        isFutureOrdersSectionVisible: !state.isFutureOrdersSectionVisible,
      };
    case OR_BUILD_ORDER_REQUEST:
      return addPendingBuildOrder(state, action.orderNumber);
    case OR_BUILD_ORDER_SUCCESS:
      return removePendingBuildOrder(state, action.orderNumber);
    case OR_BUILD_ORDER_ERROR:
      return removePendingBuildOrder(state, action.orderNumber, { addToErrorBuildOrders: true });
    default:
      return state;
  }
}
